var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('Table',{attrs:{"servicePath":'payment/list',"headers":_vm.tableHeaders,"title":_vm.tableTitle,"itemsPerPageSent":_vm.itemsPerPageSent,"sortByKey":_vm.sortBy,"sortDesc":_vm.sortDesc,"tableType":"payments","icon":"mdi-cash-multiple","tableUser":"customer"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }